import {
  useCompany
} from "./chunk-CHHP3KX4.mjs";

// src/company.tsx
import * as React from "react";
import { createContext } from "@clara/react-utils";
import { runIfFn } from "@clara/utils";
import { jsx } from "react/jsx-runtime";
var [CompanyContextProvider, useCompanyContext] = createContext({
  strict: true,
  name: "CompanyContext",
  errorMessage: "useCompanyContext: `context` is undefined. Seems you forgot to wrap company components in `<Company />`"
});
var CompanyProvider = (props) => {
  const ctx = useCompany();
  const context = React.useMemo(() => ctx, [ctx]);
  const children = runIfFn(props.children, context);
  return /* @__PURE__ */ jsx(CompanyContextProvider, { value: context, children });
};

export {
  CompanyContextProvider,
  useCompanyContext,
  CompanyProvider
};
